
import AddCartLinesLoaderState from "@dana/Store/Data/AddCartLinesLoader/AddCartLinesLoaderState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: AddCartLinesLoaderState = {
    isLoading: false,
};

const addCartLinesLoaderImmerReducer = createTypedReducerWithImmer(initialState, {

    "AddCartLinesLoader/IsLoading": (draft: Draft<AddCartLinesLoaderState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },

});

(reducers as any).addCartLinesLoader = addCartLinesLoaderImmerReducer;

type AddCartLinesLoaderReducers = {
    addCartLinesLoader: typeof addCartLinesLoaderImmerReducer;
};

export type AddCartLinesLoaderActions = Parameters<AddCartLinesLoaderReducers[keyof AddCartLinesLoaderReducers]>[1] | AnyAction;

